import { Controller } from "@hotwired/stimulus"
import { confirmDialog } from "../turbo_confirm"
import { followFrameRedirect, handleFrameNetworkError } from "../helpers/turbo_frame_error"

export default class extends Controller {
  static targets = ["selectAll", "employeeCheckbox"]

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.employeeCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = checked
    })
  }

  // The checklist arrives after "Alle auswählen" was rendered, possibly already unticked.
  employeeCheckboxTargetConnected(checkbox) {
    checkbox.checked = this.selectAllTarget.checked
  }

  // A checklist that never loads would block the submit below for good — say so instead.
  employeesMissing(event) {
    followFrameRedirect(event)
  }

  employeesFailed(event) {
    handleFrameNetworkError(event)
  }

  async confirmSubmit(event) {
    // The employee checklist loads into a lazy frame. Submitted before it arrives, the form
    // would carry no employee_ids and set the hours for nobody — wait for the list instead.
    if (!this.hasEmployeeCheckboxTarget) {
      event.preventDefault()
      return
    }

    const message = event.currentTarget.dataset.bulkWorkingHoursConfirmMessage
    if (!message) return

    event.preventDefault()
    if (await confirmDialog(message)) {
      this.element.requestSubmit()
    }
  }
}
